import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { getPanelProperties } from 'store/modules/panel_store/actions';
import Loader from 'components/atoms/loader';
import NewPanel from 'components/organisms/new_panel';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';

const Painel: React.FC = () => {
  const { request } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Painel - ConLicitação';
    dispatch(
      getPanelProperties(profile?.representant ? profile?.currentCompany[tabId()] : undefined),
    );
  }, []);

  if (request?.loading)
    return (
      <div
        className="d-flex mx-auto justify-content-center align-items-center"
        style={{ height: '70vh ' }}
      >
        <Loader />
      </div>
    );

  return <NewPanel />;
};

export default Painel;
